@if (challenge()) {
  <div>
    <p>Pairing this device with:</p>
    <p class="mb-1 mt-3">Category:</p>
    <h4>{{ challenge().category }}</h4>
    @if (challenge().parentCategory) {
      <div>
        <p class="mb-1 mt-3">Is a sub category of:</p>
        <h4>{{ challenge().parentCategory }}</h4>
      </div>
    }
    <button class="btn btn-success mt-3"
            (click)="continue()">Continue</button>
  </div>
}